import { Component, OnInit } from '@angular/core';
import { FavoritosService } from './../../services/favoritos.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss']
})

export class HomeComponent implements OnInit {
  buttonList = {
    backButton: false,
    groupButton: false,
    searchButton: true,
    viewButton: false,
    favButton: true,
    favAllButton: false,
    inFavButton: false,
  }
  favoritosList;

  constructor(
    private _favoritos: FavoritosService
  ) {
  }

  ngOnInit() {
    this._favoritos.favoritosList.subscribe(list => this.favoritosList = list);
    this.meusFavoritos();
  }

  meusFavoritos() {
    if (localStorage.getItem("favoritos") === null) {
      this._favoritos.listFav()
        .subscribe(
          (response: any) => {
            if (response.length) {
              localStorage.setItem('favoritos', JSON.stringify(response));
              this.favoritosList = response[0].Itens.map(result => result.MATNR);
            }
          }
        );
    } else {
      this.favoritosList = JSON.parse(localStorage.favoritos)[0].Itens.map(result => result.MATNR);
    }
  }

}
